import React, { useCallback } from 'react'

const FilterLabelItem = ({ label }) => {
  if (!label) return null

  return (
    <div
      style={{
        borderRadius: 4,
        backgroundColor: '#0085FF',
        display: 'block',
        margin: '0 3px',
      }}
    >
      <div
        style={{
          color: 'white',
          textTransform: 'uppercase',
          fontSize: '12px',
          lineHeight: '14px',
          fontFamily: ' Roboto, sans-serif',
          margin: '2px 10px 2px 10px',
          fontWeight: '700',
        }}
      >
        {label}
      </div>
    </div>
  )
}

export const ChartHeader = ({ selectedFilters }) => {
  const renderFilterItems = useCallback(() => {
    return Object.entries(selectedFilters).map(([key, value]) => {
      let label = value
      if (!value || value === 'null') return null
      if (key === 'stack') label = `${value} BBs`
      return <FilterLabelItem key={label} label={label} />
    })
  }, [selectedFilters])

  return (
    <div className="PreflopCharts__chart-header">{renderFilterItems()}</div>
  )
}
